import {
  SET_LEADQUELLEN,
  SET_LEADSTAGES,
  SET_LEADTYPEN,
  SET_KONTAKTROLLEN,
  SET_AKTIVITAETTYPEN,
  SET_AKTIVITAETSTATI,
  SET_KAMPAGNESTATI,
  SET_KAMPANGEEINTRAGSTATI,
  SET_KAMPAGNETEILNEHMERSTATI,
  SET_MITBEWERBERPRODUKTE,
  SET_INSTITUTIONEN,
  SET_PROZESSE,
  SET_BELEGUNGSSTATI,
  SET_EINSATZBEREICHE,
  SET_ANGEBOTSTATI,
  SET_EINSATZSTATI,
  SET_VERMITTLUNGSSTELLEN,
  SET_EINSATZORTE,
  SET_SANITAEREEINRICHTUNGEN,
  SET_SPRACHEN
} from "./mutations.type";

import { LADE_AUSWAHLWERTE_CRM } from "./actions.type";

import Api from "@/api/Api";
import AppApi from "@/api/AppApi";

export default {
  namespaced: true,
  state: {
    leadquellen: [],
    leadstages: [],
    leadtypen: [],
    kontaktrollen: [],
    aktivitaettypen: [],
    aktivitaetstati: [],
    kampagnestati: [],
    kampagneeintragstati: [],
    kampagneteilnehmerstati: [],
    mitbewerberprodukte: [],
    institutionen: [],
    prozesse: [],
    belegungsstati: [],
    einsatzbereiche: [],
    angebotstati: [],
    einsatzstati: [],
    vermittlungsstellen: [],
    einsatzorte: [],
    sanitaereeinrichtungen: [],
    sprachen: []
  },
  mutations: {
    [SET_LEADQUELLEN](state, val) {
      state.leadquellen = val;
    },
    [SET_LEADSTAGES](state, val) {
      state.leadstages = val;
    },
    [SET_LEADTYPEN](state, val) {
      state.leadtypen = val;
    },
    [SET_KONTAKTROLLEN](state, val) {
      state.kontaktrollen = val;
    },
    [SET_AKTIVITAETTYPEN](state, val) {
      state.aktivitaettypen = val;
    },
    [SET_AKTIVITAETSTATI](state, val) {
      state.aktivitaetstati = val;
    },
    [SET_KAMPAGNESTATI](state, val) {
      state.kampagnestati = val;
    },
    [SET_KAMPANGEEINTRAGSTATI](state, val) {
      state.kampagneeintragstati = val;
    },
    [SET_KAMPAGNETEILNEHMERSTATI](state, val) {
      state.kampagneteilnehmerstati = val;
    },
    [SET_MITBEWERBERPRODUKTE](state, val) {
      state.mitbewerberprodukte = val;
    },
    [SET_INSTITUTIONEN](state, val) {
      state.institutionen = val;
    },
    [SET_PROZESSE](state, val) {
      state.prozesse = val;
    },
    [SET_BELEGUNGSSTATI](state, val) {
      state.belegungsstati = val;
    },
    [SET_EINSATZBEREICHE](state, val) {
      state.einsatzbereiche = val;
    },
    [SET_ANGEBOTSTATI](state, val) {
      state.angebotstati = val;
    },
    [SET_EINSATZSTATI](state, val) {
      state.einsatzstati = val;
    },
    [SET_VERMITTLUNGSSTELLEN](state, val) {
      state.vermittlungsstellen = val;
    },
    [SET_EINSATZORTE](state, val) {
      state.einsatzorte = val;
    },
    [SET_SANITAEREEINRICHTUNGEN](state, val) {
      state.sanitaereeinrichtungen = val;
    },
    [SET_SPRACHEN](state, val) {
      state.sprachen = val;
    },
  },
  actions: {
    async [LADE_AUSWAHLWERTE_CRM](context) {
      let response = await Api.get("crm/auswahlwerte/");
      context.commit(SET_LEADQUELLEN, response.data.leadquellen);
      context.commit(SET_LEADSTAGES, response.data.leadstages);
      context.commit(SET_LEADTYPEN, response.data.leadtypen);
      context.commit(SET_KONTAKTROLLEN, response.data.kontaktrollen);
      context.commit(SET_AKTIVITAETTYPEN, response.data.aktivitaettypen);
      context.commit(SET_AKTIVITAETSTATI, response.data.aktivitaetstati);
      context.commit(SET_KAMPAGNESTATI, response.data.kampagnestati);
      context.commit(
        SET_KAMPANGEEINTRAGSTATI,
        response.data.kampagneeintragstati
      );
      context.commit(
        SET_KAMPAGNETEILNEHMERSTATI,
        response.data.kampagneteilnehmerstati
      );
      context.commit(
        SET_MITBEWERBERPRODUKTE,
        response.data.mitbewerberprodukte
      );
      context.commit(SET_INSTITUTIONEN, response.data.institutionen);

      // load selection values from AppApi
      let responseProzesse = await AppApi.get("prozess/auswahlwerte/");
      context.commit(SET_PROZESSE, responseProzesse.data.prozesse);

      let responseAngebote = await AppApi.get("angebot-auswahlwerte/");
      context.commit(SET_BELEGUNGSSTATI, responseAngebote.data.belegungsstati);
      context.commit(SET_EINSATZBEREICHE, responseAngebote.data.einsatzbereiche);
      context.commit(SET_ANGEBOTSTATI, responseAngebote.data.angebotsstati);
      context.commit(SET_EINSATZSTATI, responseAngebote.data.einsatzstati);
      context.commit(SET_VERMITTLUNGSSTELLEN, responseAngebote.data.vermittlungsstellen);
      context.commit(SET_EINSATZORTE, responseAngebote.data.einsatzorte);
      context.commit(SET_SANITAEREEINRICHTUNGEN, responseAngebote.data.sanitaereeinrichtungen);
      context.commit(SET_SPRACHEN, responseAngebote.data.sprachen);
    },
  },
};
